import { useEffect } from 'react';
import { useAtom } from 'jotai/index';
import { useTokenStorage } from 'store';

import { addressAtom } from '../store/address';
import { getStorageKeysForNetwork } from '../utils/LocalstorageUtils';

import useNetwork from './use-network';

const { getToken } = useTokenStorage();

// null when not init, '' when not logged in

// TODO_R: нужно сделать `return { walletAcount }` и пофиксить везде. С названием `walletAccount` нужно решить заранее с @yernur,
// так как не совсем понятно что это и для чего это.
const useAddress = (): string | null => {
  const [address, setAddress] = useAtom(addressAtom);
  const [network] = useNetwork();

  useEffect(() => {
    const localStorageAddress = localStorage.getItem(
      network === 'mainnet'
        ? getStorageKeysForNetwork().mainnetAddress
        : getStorageKeysForNetwork().testnetAddress
    );
    setAddress(localStorageAddress || '');
  }, [network]);

  const token = getToken();

  return token ? address : '';
};

export default useAddress;
